import { Draggable } from '@hello-pangea/dnd';
import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { useNotifier } from '@provider/notifier';
import { PencilIcon, IconButton, TrashIcon, Tooltip, HandleIcon } from '@ui/kit';
import { BlockIcon } from './block-icon.js';
import { blockCls, inputWrapperCls, inputCls, pencilCls, buttonsCls, handleCls } from './block.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useUpdateCourseMutation } from '../../../../api/mutation.update.js';

function Block(props) {
  const notifier = useNotifier();
  const updateCourse = useUpdateCourseMutation();
  const [tmpTitle, titleCallbacks] = useEphemeralTitleInput(props);
  const handleDeleteClick = async () => {
    if (!props.course?.blocks) {
      return;
    }
    const res = await notifier.confirm({
      type: "slide-up",
      heading: "Vil du slette elementet?",
      body: "Bemærk at denne handling ikke kan fortrydes.",
      labels: {
        ok: "Slet"
      }
    });
    if (res !== "ok") {
      return;
    }
    updateCourse.mutate({
      oldCourse: props.course,
      newCourse: {
        ...props.course,
        blocks: props.course.blocks.filter(it => it.id !== props.block.id)
      },
      options: {
        silent: true,
        includeBlocks: true
      }
    });
  };
  return /*#__PURE__*/jsx(Draggable, {
    draggableId: props.block.id,
    index: props.index,
    children: (provided, snapshot) => /*#__PURE__*/jsxs("div", {
      ...provided.draggableProps,
      ref: provided.innerRef,
      className: cx(blockCls, !snapshot.isDragging && props.isDragActive && "inactive"),
      children: [/*#__PURE__*/jsx(BlockIcon, {
        block: props.block
      }), /*#__PURE__*/jsxs("div", {
        className: inputWrapperCls,
        children: [/*#__PURE__*/jsx("input", {
          ...titleCallbacks,
          className: inputCls,
          "aria-label": "Rediger titel",
          type: "text",
          value: tmpTitle
        }), /*#__PURE__*/jsx(PencilIcon, {
          className: pencilCls
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: buttonsCls,
        children: [/*#__PURE__*/jsx(IconButton, {
          size: "small",
          icon: /*#__PURE__*/jsx(TrashIcon, {
            height: 16
          }),
          label: "Slet element",
          onClick: handleDeleteClick
        }), /*#__PURE__*/jsx(Tooltip, {
          placement: "top",
          body: "Arranger element",
          ariaType: "label",
          offsetPx: 5,
          disabled: snapshot.isDragging,
          children: ref => /*#__PURE__*/jsx("span", {
            ...provided.dragHandleProps,
            ref: ref,
            className: handleCls,
            children: /*#__PURE__*/jsx(HandleIcon, {})
          })
        })]
      })]
    })
  });
}
function useEphemeralTitleInput(props) {
  const updateCourse = useUpdateCourseMutation();
  const [tmpTitle, setTmpTitle] = useState(props.block.title);
  const updateBlockTitle = () => {
    // No need to save if nothing has been changed
    if (props.block.title === tmpTitle) {
      return;
    }
    if (!props.course?.blocks) {
      return;
    }
    const blockIndex = props.course.blocks?.findIndex(it => it.id === props.block.id);
    const newBlocks = [...props.course.blocks];
    newBlocks.splice(blockIndex, 1, {
      ...props.block,
      title: tmpTitle
    });
    updateCourse.mutate({
      oldCourse: props.course,
      newCourse: {
        ...props.course,
        blocks: newBlocks
      },
      options: {
        silent: true,
        includeBlocks: true
      }
    });
  };
  const onKeyDown = evt => {
    if (evt.key === "Enter") {
      evt.preventDefault();
      evt.currentTarget.blur();
    }
  };
  const onBlur = () => {
    updateBlockTitle();
  };
  const onChange = evt => {
    setTmpTitle(evt.currentTarget.value);
  };
  useEffect(() => {
    setTmpTitle(props.block.title);
  }, [props.block.title]);
  return [tmpTitle, {
    onKeyDown,
    onBlur,
    onChange
  }];
}

export { Block };
//# sourceMappingURL=block.js.map
